export const SUBMIT = 'lumahealth/SignupPage/SUBMIT';
export const SUBMIT_SUCCESS = 'lumahealth/SignupPage/SUBMIT_SUCCESS';
export const SUBMIT_ERROR = 'lumahealth/SignupPage/SUBMIT_ERROR';
